module.exports = __webpack_public_path__ + "static/media/Icon4.f71e3485.png";